import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserTypes } from "../../../../core/Enums";
import { getOwner, getUser, setPage, useGlobal } from '../../../../core/Global';
import Avatar from "../../../../components/base/Avatar";
import Icon from "../../../../components/base/Icon";

type IProps = {
    selectedPage?: string
}

export default function AccountHeader(props: IProps) {

    const user = getUser()
    const owner = getOwner()

    return (
        <div className="card mb-5">
            <div className="card-body pt-9 pb-0">
                <div className="d-flex flex-wrap flex-sm-nowrap">
                    <div className="me-7 mb-4">
                        <Avatar avatarUrl={user?.avatarUrl}
                            fullName={user?.fullName}
                            textSize={60}
                            type="square"
                            width={100} />
                    </div>
                    <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                            <div className="d-flex flex-column">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="text-gray-900 fs-2 fw-bolder me-1">
                                        {user?.fullName}
                                    </span>
                                    {/* <a href="#" className="btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3" data-bs-toggle="modal" data-bs-target="#kt_modal_upgrade_plan">Upgrade to Pro</a> */}
                                </div>
                                <div className="d-flex flex-wrap fw-bold fs-6 mb-3 pe-2">
                                    <div className="d-flex align-items-center text-gray-500 me-5">
                                        <Icon icon="at" className="me-1" />
                                        {user?.username}
                                    </div>
                                    <div className="d-flex align-items-center text-gray-500">
                                        {
                                            user?.userType == UserTypes.Admin ?
                                                <Icon icon="user-tie" type="solid" className="me-1" />
                                                : user?.userType == UserTypes.Agent ?
                                                    <Icon icon="user-headset" type="solid" className="me-1" />
                                                    : <></>
                                        }
                                        {user?.userTypeName}
                                    </div>
                                </div>

                                <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                    <div className="d-flex align-items-center text-gray-500 me-5">
                                        <Icon icon="briefcase" type="solid" className="me-1" />
                                        <span style={{ paddingTop: 2 }}>{owner?.companyName}</span>
                                    </div>
                                </div>

                            </div>
                            <div className="d-flex">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
